import { useMemo, useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { backupListService } from '../services/backupList.service';
import { toast } from 'sonner';

export function useBackupList() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['settings1', 'backup', 'list', companyId],
    queryFn: () => backupListService.getBackups(companyId),
    enabled: !!companyId,
  });

  const createMutation = useMutation({
    mutationFn: () => backupListService.createBackup(companyId, profile?.id || ''),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings1', 'backup'] });
      toast.success('Đã tạo thành công bản sao lưu mới!');
    },
    onError: () => toast.error('Lỗi khi tạo bản sao lưu')
  });

  const deleteMutation = useMutation({
    mutationFn: backupListService.deleteBackup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings1', 'backup'] });
      toast.success('Đã xóa bản sao lưu');
    },
    onError: () => toast.error('Lỗi khi xóa bản sao lưu')
  });

  return {
    backups: query.data || [],
    isLoading: query.isLoading,
    isCreating: createMutation.isPending,
    createBackup: createMutation.mutate,
    deleteBackup: deleteMutation.mutate,
    isDeleting: deleteMutation.isPending
  };
}
